import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.nevod = bracketIndenting()
